import React, {Fragment} from 'react'
import { connect } from "react-redux"
import Fab from '@material-ui/core/Fab';
import Spinner from '../components/Spinner'
import RegisterPlan from '../components/RegisterPlan'
import {checkPhoneNumber, checkNumeric, checkEmail, checkEmailPremium, checkPhonePremium, validateEmailDomain} from '../utils/Helper'
import {fieldErrors} from '../utils/errors'
import { graphql, StaticQuery, navigate, Link } from 'gatsby'
import HeaderPlain from '../components/HeaderPlain'
import { logPage, logEvent, pushToDataLayer } from '../components/Analytics'

class Register extends React.Component{
    constructor(props){
        super(props)

        this.state = {
			loading: false,
			disabled: false,
			emailDomainError: ''
		}
	}
		
	componentDidMount(){
        logPage()
	}

	handleInput = (e) => {
		this.setState({emailDomainError: ''})
		if(validateEmailDomain(e.target.value)){
			this.setState({emailDomainError: fieldErrors.emailDomain})
		}
    }
	
    registerForm = () => {
        const { registerPlan, registerEmail, registerPhoneNumber, registerTermCondition, dispatchError, dispatchEmailError, dispatchCheckboxError, dispatchPhoneError } = this.props;

		dispatchEmailError('')
		dispatchCheckboxError('')
		dispatchPhoneError('')

        if (!registerEmail.length) return dispatchEmailError(fieldErrors.emailEmpty)
		if (!checkEmail(registerEmail)) return dispatchEmailError(fieldErrors.invalidEmail)
		
		if(registerPlan === 'senior'){
			if(registerPhoneNumber === '') return dispatchPhoneError(fieldErrors.phoneNumberEmpty)
			if(!checkNumeric(registerPhoneNumber)) return dispatchPhoneError(fieldErrors.phoneNumber)
			if(!checkPhoneNumber(registerPhoneNumber)) return dispatchPhoneError(fieldErrors.phoneNumberFormat)
		}
		if (!registerTermCondition) return dispatchCheckboxError(fieldErrors.terms)
        
        this.setState({loading: true, disabled: true})

		dispatchError('')
		checkEmailPremium(registerEmail, (resp) => {
			if(!resp){
				if(registerPlan === 'senior'){
					checkPhonePremium(registerPhoneNumber, (phoneResp) => {
						if(!phoneResp){
							navigate('/checkout');
						}else{
							this.setState({loading: false, disabled: false})
							dispatchPhoneError(fieldErrors.userAlreadyPremiumWithPhone)
						}
					})
				}else{
					navigate('/checkout');
				}
			}else{
                this.setState({loading: false, disabled: false})
				dispatchEmailError(fieldErrors.userAlreadyPremium)
			}			
		})
    }

    render(){
        const { loading, disabled, emailDomainError } = this.state
        const { registerEmailError, registerCheckboxError, registerPhoneError, errorMessage, registerPlan, registerEmail, registerPhoneNumber, registerTermCondition, dispatchRegisterEmail, dispatchRegisterPhone, dispatchRegisterTermCondition } = this.props;

        return(
            <Fragment>
				<HeaderPlain logoColor="#46e2b9" headerClass="leftlogoheader" title="Albert" />
				
				<div className="centerForm">
					<div className='accountFormContainerMobile' id="accountForm">
						<form>
							<div className="steps-inner-line">
								<ul>
									<li className='active'>
										<span></span>
									</li>
									<li>
										<span></span>
									</li>								
								</ul>							
							</div>

							<div>
								<div className='accountFormContent'>
									<h2>Prova gratis i 30 dagar!</h2>
									<p>Ange ålder och e-postadress för att skapa ett <br/> 
									konto. Instruktioner, kod och uppdateringar <br/>  skickas som e-post.</p>
								</div>
								
								<RegisterPlan/>

								<div className='accountFormEmail'>
									<h4>E-post</h4>
									<input className={typeof registerEmailError !== 'undefined' && registerEmailError !== '' ? 'errorField' : ''} type='text' id='email' value={registerEmail} onChange={ e => {dispatchRegisterEmail(e.target.value); this.handleInput(e)}} placeholder="Ange E-postadress"/>
									<label className="text-error">{registerEmailError}</label>
									<label className="text-error">{emailDomainError}</label>
								</div>

								{
									registerPlan === 'senior' && (
										<div className='accountFormEmail'>
											<h4>Ditt barns Telefonnummer</h4>
											<input className={registerPhoneError !== '' ? 'errorField' : ''} type='text' id='phone' value={registerPhoneNumber}  onChange={e => dispatchRegisterPhone(e.target.value)} pattern="\d*" placeholder="Ange mobilnummer"/>
											<label className="text-error">{registerPhoneError}</label>
										</div>
									)
								}

								<div className='accountFormRegisterButtonMobile'>
									<input type='checkbox' id='terms_and_conditions' onChange={() => dispatchRegisterTermCondition(!registerTermCondition)} />
									<label htmlFor='terms_and_conditions'>Jag godkänner Alberts <a href="https://hejalbert.se/terms-and-conditions" target="_blank" className='color-text'> Allmänna Villkor </a></label>
								</div>
								<label className="text-error">{registerCheckboxError}</label>
									<Fab
										variant="extended"
										color="primary"
										aria-label="Add"
										className="registerButton"
										disabled={disabled}
										onClick={(e) => {
												this.registerForm(e);
												logEvent(
													`Register page Skapa Konto button`,
													`Register page Skapa Konto button was clicked`
												);
												pushToDataLayer(
													'userClick',
													'Register Page Skapa Konto Button',
													'Register Page Skapa Konto Button Was Clicked'
												)
											}
										}
										>
										Skapa Konto
									</Fab>
									<br/>
									{
										loading && (
											<Spinner size={48}/>
										)
									}
							</div>
						</form>
					</div>
				</div>
			</Fragment>
		)				
    }
}

const reduxRegisterPageState = (state) => {
    return {
        registerEmail: state.registerEmail,
        registerPhoneNumber: state.registerPhoneNumber,
        registerTermCondition: state.registerTermCondition,
        registerPlan: state.registerPlan,
		errorMessage: state.errorMessage,
		registerEmailError: state.registerEmailError,
		registerPhoneError: state.registerPhoneError,
		registerCheckboxError: state.registerCheckboxError,
    }
}

const reduxRegisterPageStateDispatch = dispatch => {
    return { 
        dispatchRegisterEmail: (email) => dispatch({ type: `REGISTER_EMAIL`, value: email }),
        dispatchRegisterPhone: (phone) => dispatch({ type: `REGISTER_PHONE_NUMBER`, value: phone }),
        dispatchRegisterTermCondition: (condiition) => dispatch({ type: `REGISTER_TERM_CONDITION`, value: condiition }),
        dispatchError: (error) => dispatch({ type: `ERROR_MESSAGE`, value: error }),
		dispatchEmailError: (error) => dispatch({ type: `REGISTER_EMAIL_ERROR`, value: error }),
		dispatchPhoneError: (error) => dispatch({ type: `REGISTER_PHONE_ERROR`, value: error }),
		dispatchCheckboxError: (error) => dispatch({ type: `REGISTER_CHECKBOX_ERROR`, value: error }),
    }
}

export default connect(reduxRegisterPageState, reduxRegisterPageStateDispatch)(Register);